<script>
	let { event } = $props();

	function formatDate(dateStr) {
		const date = new Date(dateStr + 'T00:00:00');
		return date.toLocaleDateString('en-US', {
			weekday: 'long',
			month: 'long',
			day: 'numeric'
		});
	}

	function formatDateRange(start, end) {
		if (!end || end === start) return formatDate(start);
		return `${formatDate(start)} — ${formatDate(end)}`;
	}
</script>

<a
	href="/events/{event.id}/"
	class="group flex h-full flex-col overflow-hidden rounded-lg border-2 border-stone-dark bg-altar-white shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-gold hover:shadow-lg active:scale-[0.98]"
>
	{#if event.imageUrl}
		<div class="p-3 pb-0">
			<img
				src={event.imageUrl}
				alt={event.title}
				class="aspect-[3/4] w-full rounded object-cover"
				loading="lazy"
			/>
		</div>
	{/if}
	<div class="flex flex-1 flex-col p-4 pt-3">
		<h3 class="font-heading text-xl font-semibold text-navy group-hover:text-wine md:text-2xl">{event.title}</h3>
		<p class="mt-2 text-base text-navy-muted">
			{formatDateRange(event.date, event.endDate)}
			{#if event.time}
				<span class="mx-1">·</span> {event.time}
			{/if}
		</p>
		{#if event.location}
			<p class="mt-1 text-base text-navy-muted">{event.location}</p>
		{/if}
		{#if event.blurb}
			<p class="mt-3 text-base leading-relaxed text-navy-light">{event.blurb}</p>
		{/if}
		<p class="mt-auto pt-4 text-base font-medium text-wine group-hover:text-wine-dark">Learn more →</p>
	</div>
</a>
